import { createContext, useContext } from 'react';

const UpgradeContext = createContext(null);
export const useUpgradeExperience = () => useContext(UpgradeContext);
export default UpgradeContext;
